/**
 * YouTube channel art specs. Official source: YouTube Help "Manage your channel branding"
 * (recommended 2560×1440, minimum 2048×1152, 6 MB, safe area 1235×338 at the minimum size).
 * 1546×423 is that safe area scaled to the 2560×1440 canvas. Last verified 2026-10-16.
 * @see https://support.google.com/youtube/answer/10456525
 */
export const YOUTUBE_CHANNEL_BANNER_SOURCE_URL = 'https://support.google.com/youtube/answer/10456525';
export const YOUTUBE_CHANNEL_BANNER_LAST_VERIFIED = '2026-10-16';

export const YOUTUBE_CHANNEL_BANNER_SPECS = {
  recommendedSize: '2560 × 1440 px',
  safeZone: '1546 × 423 px',
  minimumSize: '2048 × 1152 px',
  maxFileSize: '6 MB',
  formats: 'JPG, PNG, GIF, BMP',
} as const;
